import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DashboardConfig } from '../../types/widget';

interface DashboardState {
  currentDashboard: DashboardConfig | null;
  dashboards: DashboardConfig[];
  isLoading: boolean;
  error: string | null;
}

const initialState: DashboardState = {
  currentDashboard: null,
  dashboards: [],
  isLoading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setCurrentDashboard: (state, action: PayloadAction<DashboardConfig>) => {
      state.currentDashboard = action.payload;
    },
    setDashboards: (state, action: PayloadAction<DashboardConfig[]>) => {
      state.dashboards = action.payload;
    },
    addDashboard: (state, action: PayloadAction<DashboardConfig>) => {
      state.dashboards.push(action.payload);
    },
    updateDashboard: (state, action: PayloadAction<DashboardConfig>) => {
      const index = state.dashboards.findIndex(d => d.id === action.payload.id);
      if (index !== -1) {
        state.dashboards[index] = action.payload;
      }
      if (state.currentDashboard?.id === action.payload.id) {
        state.currentDashboard = action.payload;
      }
    },
    deleteDashboard: (state, action: PayloadAction<string>) => {
      state.dashboards = state.dashboards.filter(d => d.id !== action.payload);
      if (state.currentDashboard?.id === action.payload) {
        state.currentDashboard = null;
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const {
  setCurrentDashboard,
  setDashboards,
  addDashboard,
  updateDashboard,
  deleteDashboard,
  setLoading,
  setError,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
